import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { OrderCreateFormValues } from "@/types/order-type";
import { UseFormReturn } from "react-hook-form";

const hiddenFieldNames = [
  "status",
] as const satisfies readonly (keyof OrderCreateFormValues)[];

type HiddenFieldName = (typeof hiddenFieldNames)[number];

interface HiddenFieldsSectionProps {
  form: UseFormReturn<OrderCreateFormValues>;
}

export function HiddenFieldsSection({ form }: HiddenFieldsSectionProps) {
  return (
    <>
      {hiddenFieldNames.map((name) => (
        <FormField
          key={name}
          control={form.control}
          name={name as HiddenFieldName}
          render={({ field }) => (
            <FormItem style={{ display: "none" }}>
              <FormControl>
                <input type="hidden" {...field} />
              </FormControl>
            </FormItem>
          )}
        />
      ))}
    </>
  );
}
